/* eslint-disable no-console */
import React, { useState, useCallback, useEffect } from 'react';
import { Button, Card, Layout, TextContainer, Modal } from '@shopify/polaris';
import { useMutation } from '@apollo/react-hooks';
import { useTenantContext } from 'src/components/TenantProvider';
import DisconnectShopFromTenant from 'src/mutations/DisconnectShopFromTenant';
import { SWITCH_THINKIFIC_ACCOUNT } from './constants';

const DisconnectSection = () => {
  const { session, onLogOut } = useTenantContext();
  const [modalActive, setModalActive] = useState(false);
  const [disconnect, { data, loading }] = useMutation(DisconnectShopFromTenant);

  const toggleModal = useCallback(() => {
    if (loading) {
      return;
    }
    setModalActive(!modalActive);
  }, [modalActive, loading]);

  const handleDisconnect = useCallback(() => {
    disconnect({ variables: { sessionId: session.id } });
  }, [disconnect, session]);

  useEffect(() => {
    if (!data) {
      return;
    }
    console.log(data);
    onLogOut();
  }, [data, onLogOut]);

  return (
    <>
      <Layout.AnnotatedSection title={SWITCH_THINKIFIC_ACCOUNT.title}>
        <Card>
          <Card.Section subdued>
            <TextContainer>
              <p>{SWITCH_THINKIFIC_ACCOUNT.text}</p>
              <Button primary onClick={toggleModal}>
                {SWITCH_THINKIFIC_ACCOUNT.button}
              </Button>
            </TextContainer>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
      <Modal
        open={modalActive}
        primaryAction={{
          content: SWITCH_THINKIFIC_ACCOUNT.modal.action,
          onAction: handleDisconnect,
          loading,
          disabled: loading,
        }}
        secondaryActions={[
          {
            content: SWITCH_THINKIFIC_ACCOUNT.modal.cancel,
            onAction: toggleModal,
            disabled: loading,
          },
        ]}
        title={SWITCH_THINKIFIC_ACCOUNT.modal.title}
        onClose={toggleModal}
      >
        <Modal.Section>
          <TextContainer>
            <ul>
              <li>{SWITCH_THINKIFIC_ACCOUNT.modal.texts[0]}</li>
              <li>{SWITCH_THINKIFIC_ACCOUNT.modal.texts[1]}</li>
            </ul>
          </TextContainer>
        </Modal.Section>
      </Modal>
    </>
  );
};

export default DisconnectSection;
